import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Credential Requests|Complete Rebuild Request Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryCompleteRebuildRequest';
export type SPCandidateHistoryCompleteRebuildRequestLocNames =
	| `${LocNameStart}TitleModal`
	| `${LocNameStart}ContentInstructions`
	| `${LocNameStart}LabelComments`
	| `${LocNameStart}ErrorCommentsRequired`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonContinue`;

export const spCandidateHistoryCompleteRebuildRequestLocs: LocDefs<SPCandidateHistoryCompleteRebuildRequestLocNames> =
	{
		SPCandidateHistoryCompleteRebuildRequestTitleModal: {
			defaultValue: 'Rebuild Request',
			description: 'Modal Title',
			displayPath: `${pathStart}Modal Title`,
			displayType: 'Title',
			legacyName: 'Credential/CompleteRebuildRequestModal.Title.RebuildRequest',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryCompleteRebuildRequestContentInstructions: {
			defaultValue:
				"All credential data for this candidate will be removed from the system. The system will then begin with the earliest date a credential, exam, or other requirement was created and rebuild the candidate's credential history up until the present; manual changes will be preserved. This rebuild will take a few minutes.",
			description: 'Modal Instructions',
			displayPath: `${pathStart}Modal Instructions`,
			displayType: 'Content',
			legacyName: 'Credential/CompleteRebuildRequestModal.Content.Instructions',
			htmlAllowed: true,
			...sharedProperties,
		},
		SPCandidateHistoryCompleteRebuildRequestLabelComments: {
			defaultValue: 'Comments',
			description: 'Label for: Comments',
			displayPath: `${pathStart}Comments`,
			displayType: 'Label',
			legacyName: 'Credential/CompleteRebuildRequestModal.FieldLabel.Comments',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryCompleteRebuildRequestErrorCommentsRequired: {
			defaultValue: 'This field is required',
			description: 'Error message for: Comments is required',
			displayPath: `${pathStart}Comments required`,
			displayType: 'Error',
			legacyName: 'Credential/CompleteRebuildRequestModal.FieldError.CommentsRequired',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryCompleteRebuildRequestButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Credential/CompleteRebuildRequest.Modal.Button.Cancel',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryCompleteRebuildRequestButtonContinue: {
			defaultValue: 'Continue',
			description: 'Continue button',
			displayPath: `${pathStart}Continue`,
			displayType: 'Button',
			legacyName: 'Credential/CompleteRebuildRequest.Modal.Button.Continue',
			htmlAllowed: false,
			...sharedProperties,
		},
	};

export type SPCandidateHistoryCompleteRebuildRequestLocType =
	LocMap<SPCandidateHistoryCompleteRebuildRequestLocNames>;
